import { setSendMessagePending } from './actions';
import { TThunkAction } from '../../types/redux/thunk';
import { createOutcomingMessage } from '../../utils/messageUtils';
import { sendWsMessage } from '../wsMessage';

interface ISendMessageParams {
  text: string;
  chatId: string;
  messageId?: string;
  payload?: string;
}

export const sendMessage =
  ({ text, chatId, messageId, payload }: ISendMessageParams): TThunkAction<void> =>
  async (dispatch, getState, context) => {
    const {
      user: { userId },
    } = getState();

    const message = createOutcomingMessage({ text, chatId, userId, payload });

    dispatch(
      setSendMessagePending({
        message,
        messageId: messageId || message.messageId,
        messagesMap: context.custom.messagesMap,
      }),
    );

    await dispatch(sendWsMessage({ message }));
  };
